
/* SANTO CAFÉ SKIN JS — v23 gedrag + echt Shopify product-form */
(function(){
  var h=document.querySelector('.santo .title-panel h1');
  function fit(){
    if(!h) return;
    h.style.fontSize='';
    var fs=parseFloat(getComputedStyle(h).fontSize);
    /* One measurement, one proportional estimate, then at most a few corrective
       half-pixel steps. The old loop wrote and re-read layout up to 60 times. */
    var sw=h.scrollWidth, cw=h.clientWidth;
    if(sw<=cw) return;
    var fs2=Math.max(11,Math.floor(fs*(cw/sw)*2)/2);
    h.style.fontSize=fs2+'px';
    var guard=0;
    while(h.scrollWidth>h.clientWidth&&fs2>11&&guard<6){fs2-=.5;h.style.fontSize=fs2+'px';guard++;}
  }
  window.addEventListener('resize',fit);
  if(document.fonts&&document.fonts.ready){document.fonts.ready.then(fit);}
  fit(); window.addEventListener('load',fit);
})();
(function(){
  var box=document.querySelector('[data-buybox]');
  if(!box) return;
  function J(sel){var n=box.querySelector(sel);if(!n)return null;try{return JSON.parse(n.textContent);}catch(e){return null;}}
  var VARIANTS=J('[data-bx-variants]')||[], GROUPS=J('[data-bx-groups]')||[], T=J('[data-bx-strings]')||{};
  if(!VARIANTS.length) return;

  var CUPS=parseFloat(box.dataset.cups)||22;
  var doc=document;
  function $(s,r){return (r||box).querySelector(s);}
  function $$(s,r){return Array.prototype.slice.call((r||box).querySelectorAll(s));}
  /* Round half DOWN at the exact half-cent: 8,055 -> 8,05 and 17,005 -> 17,00,
     which is what the locked price table specifies. Epsilon guards float noise. */
  function r2(n){var x=n*100,f=Math.floor(x),d=x-f;return (d>0.5+1e-9?f+1:f)/100;}
  var lang=(doc.documentElement.getAttribute('lang')||'nl').slice(0,2), nf;
  try{nf=new Intl.NumberFormat(lang,{style:'currency',currency:'EUR'});}catch(e){nf=null;}
  function eur(n){return nf?nf.format(n):'€'+n.toFixed(2);}

  /* Tier -> selling plan is mapped by gid, never by name. Renaming a plan in
     admin must not silently drop the buy box back to one-time pricing. */
  function gidNum(v){var m=String(v||'').match(/(\d+)\s*$/);return m?m[1]:'';}
  var TIERS=$$('[data-bx-tier]').map(function(b){return {
    el:b,
    units:parseInt(b.dataset.units,10)||1,
    once:(parseFloat(b.dataset.once)||0)/100,
    gid:{4:gidNum(b.dataset.gid4),2:gidNum(b.dataset.gid2)},
    label:b.dataset.label||''
  };});
  if(!TIERS.length) return;
  var grindBtns=$$('[data-bx-grind]');

  var variantInput=$('[data-bx-variant]'), qtyInput=$('[data-bx-qty]'),
      planInput=$('[data-bx-plan]'), propInput=$('[data-bx-prop]'),
      freqOpts=$('[data-bx-freqo]'), subline=$('[data-bx-subline]');

  function variantById(id){
    for(var i=0;i<VARIANTS.length;i++){if(String(VARIANTS[i].id)===String(id))return VARIANTS[i];}
    return VARIANTS[0];
  }
  /* Shopify applies an automatic discount PER UNIT and truncates that discount to
     whole cents, then multiplies by quantity. Verified against the live cart:
     5%  -> 8,95 - 0,44 = 8,51 x4 = 34,04
     15% -> 8,95 - 1,34 = 7,61 x8 = 60,88
     Computing at line level here disagrees with checkout by a few cents, so don't. */
  function floor2(n){return Math.floor(n*100+1e-9)/100;}
  function onceUnit(t,v){return r2(v.price-floor2(v.price*t.once));}
  function onceOf(t,v){return r2(onceUnit(t,v)*t.units);}
  /* Null means the configured plan is not in selling_plan_allocations.
     Callers MUST treat null as "subscription unavailable" and show no price —
     never a computed one. A displayed price the cart would not honour is the
     worst failure mode this buy box can have. */
  function subOf(t,v,weeks){
    var id=t.gid[weeks];
    if(!id) return null;
    var unit=(v.plans&&Object.prototype.hasOwnProperty.call(v.plans,id))?v.plans[id]:null;
    if(unit==null) return null;
    return {price:r2(unit*t.units), id:id, weeks:weeks};
  }
  function weeksAvailable(t,v){
    return [4,2].filter(function(w){return subOf(t,v,w)!==null;});
  }
  function weekLabel(w){return w===2?(T.every2||'Every 2 weeks'):(T.every4||'Every 4 weeks');}

  /* Bags · cups · fit, with the cup count dropped when the row cannot hold it.
     Measured rather than breakpointed, because German and French run longer than Dutch. */
  function fitMetas(){
    TIERS.forEach(function(tt){
      var meta=tt.el.querySelector('[data-bx-tmeta]');
      if(!meta) return;
      var bags=(T.bags||'{n}').replace('{n}',tt.units);
      var cups=(T.cups||'{n}').replace('{n}',Math.round(tt.units*CUPS));
      var wide=bags+' \u00B7 '+cups;
      var slim=bags;
      meta.textContent=wide;
      if(meta.scrollWidth>meta.clientWidth+1) meta.textContent=slim;
    });
  }

  var state={ti:(TIERS.length>=2?1:0), vid:(variantInput&&variantInput.value)||VARIANTS[0].id, mode:'once', weeks:4};

  function renderFreq(t,v){
    if(!freqOpts) return;
    var list=weeksAvailable(t,v);
    var sig=list.join('|');
    if(freqOpts.dataset.sig!==sig){
      freqOpts.innerHTML='';
      list.forEach(function(w){
        var b=doc.createElement('button');
        b.type='button'; b.className='bx-f'; b.setAttribute('role','radio'); b.dataset.weeks=String(w);
        b.innerHTML='<span class="bx-dot" aria-hidden="true"></span><span class="bx-fn"></span>';
        b.querySelector('.bx-fn').textContent=weekLabel(w);
        freqOpts.appendChild(b);
      });
      freqOpts.dataset.sig=sig;
    }
    if(list.indexOf(state.weeks)===-1) state.weeks=(list.indexOf(4)!==-1)?4:list[0];
    freqOpts.hidden=(state.mode!=='sub')||!list.length;
    $$('[data-weeks]',freqOpts).forEach(function(b){
      b.setAttribute('aria-checked',parseInt(b.dataset.weeks,10)===state.weeks?'true':'false');
    });
  }

  function render(){
    var t=TIERS[state.ti], v=variantById(state.vid);
    var once=onceOf(t,v);
    var si=subOf(t,v,state.weeks);
    if(si===null&&weeksAvailable(t,v).length){ state.weeks=weeksAvailable(t,v)[0]; si=subOf(t,v,state.weeks); }
    var subAvailable=(si!==null);
    if(!subAvailable&&state.mode==='sub') state.mode='once';   /* hard guard */
    var isSub=state.mode==='sub';
    var shown=isSub?si.price:once;

    /* the tier drives quantity; quantity never drives the tier */
    if(variantInput) variantInput.value=v.id;
    if(qtyInput) qtyInput.value=t.units;
    if(planInput){
      var pid=(isSub&&si)?String(si.id):'';
      planInput.value=pid; planInput.disabled=!pid;
    }
    if(propInput){
      var bits=[t.label];
      if(grindBtns.length) bits.push(String(v.title).toLowerCase());
      bits.push(isSub?weekLabel(state.weeks).toLowerCase():String(T.once||'').toLowerCase());
      propInput.value=bits.join(' · ');
    }

    /* tier cards */
    TIERS.forEach(function(tt,i){
      var tFull=r2(v.price*tt.units);
      var tSub=isSub?subOf(tt,v,state.weeks):null;
      var tShown=isSub?(tSub?tSub.price:null):onceOf(tt,v);
      tt.el.setAttribute('aria-checked',i===state.ti?'true':'false');
      tt.el.disabled=!v.available;
      var now=tt.el.querySelector('.bx-tnow'); if(now) now.textContent=(tShown==null)?'—':eur(tShown);
      /* struck-through original total, only when this tier is actually discounted */
      var sv=tt.el.querySelector('[data-bx-save]');
      if(sv) sv.textContent=(tShown<tFull-0.005)?eur(tFull):'';
      /* meta text is written here, then measured and trimmed in fitMetas() */
    });

    grindBtns.forEach(function(b){
      b.setAttribute('aria-checked',String(b.dataset.bxGrind)===String(v.id)?'true':'false');
    });

    /* toggle */
    $$('[data-bx-mode]').forEach(function(b){
      b.setAttribute('aria-pressed',b.dataset.bxMode===state.mode?'true':'false');
    });
    var op=$('[data-bx-onceprice]'); if(op) op.textContent=eur(once);
    var sp=$('[data-bx-subprice]'); if(sp) sp.textContent=subAvailable?eur(si.price):'—';
    var subBtn=$('[data-bx-mode="sub"]');
    if(subBtn){
      subBtn.disabled=!subAvailable;
      subBtn.setAttribute('aria-disabled',subAvailable?'false':'true');
      subBtn.title=subAvailable?'':(T.subunavail||'');
    }
    renderFreq(t,v);
    if(subline){
      subline.hidden=!(isSub&&subAvailable);
      /* says what actually arrives, so nobody is surprised in week two */
      subline.textContent=t.label+' '+weekLabel(state.weeks).toLowerCase()+' \u00B7 '+(T.pause||'');
    }

    var cta=$('[data-bx-cta]');
    if(cta){
      cta.disabled=!v.available;
      cta.textContent=v.available?((T.cta||'Add to cart')+' · '+eur(shown)):(T.soldout||'Sold out');
    }

    /* fitMetas() is deliberately NOT called here: its text derives only from
       tt.units and CUPS, both constant, so the result is identical on every
       render - while the measuring it does forces a synchronous layout that
       cost ~30ms on every tap. Run it on init, on resize, and once webfont
       metrics settle instead. */

    /* sticky */
    var ss=doc.querySelector('[data-bx-stickysub]');
    if(ss) ss.textContent=propInput?propInput.value:t.label;
    var st=doc.querySelector('[data-bx-stickytotal]');
    if(st) st.textContent=eur(shown);
    var sc=doc.querySelector('[data-bx-stickycta]');
    if(sc) sc.textContent=v.available?(T.cta||'Add to cart'):(T.soldout||'Sold out');
  }

  grindBtns.forEach(function(b){b.addEventListener('click',function(){state.vid=b.dataset.bxGrind;render();});});
  TIERS.forEach(function(t,i){t.el.addEventListener('click',function(){state.ti=i;render();});});
  $$('[data-bx-mode]').forEach(function(b){b.addEventListener('click',function(){state.mode=b.dataset.bxMode;render();});});
  if(freqOpts){freqOpts.addEventListener('click',function(ev){
    var b=ev.target.closest('[data-weeks]');
    if(!b) return;
    state.weeks=parseInt(b.dataset.weeks,10)||4;
    state.mode='sub';
    render();
  });}

  /* Deep links, used by the replenishment mail:
       ?tier=1|2|3   500 g / 1 kilo / 2 kilo
       ?plan=once|sub
       ?weeks=2|4
     Invalid values are ignored. The hard guard in render() still drops back to
     one-time if the requested plan is not available, so a bad link can never
     show a price that will not be charged. Nothing here runs without a param. */
  (function(){
    try{
      var q=new URLSearchParams(location.search);
      var t=parseInt(q.get('tier'),10); if(t>=1&&t<=TIERS.length) state.ti=t-1;
      var p=q.get('plan'); if(p==='sub'||p==='once') state.mode=p;
      var w=parseInt(q.get('weeks'),10); if(w===2||w===4) state.weeks=w;
    }catch(e){}
  })();
  render();
  fitMetas();
  if(document.fonts&&document.fonts.ready){document.fonts.ready.then(fitMetas);}

  window.addEventListener('resize',fitMetas);

  /* sticky CTA: visible whenever the real CTA is off-screen and the box has been reached */
  var bar=doc.querySelector('[data-sticky]');
  if(bar){
    var scta=doc.querySelector('[data-bx-stickycta]');
    if(scta){scta.addEventListener('click',function(){
      var f=box.closest('form')||box;
      if(f.requestSubmit) f.requestSubmit(); else f.submit();
    });}
    /* The bar tracks the real CTA only. ctaPassed distinguishes "scrolled up out
       of view" from "still below the fold" - without it the bar shows on load,
       because at the top of the page the CTA is simply not visible yet. */
    var ctaPassed=false;
    function footVisible(){var vis=false;doc.querySelectorAll('footer').forEach(function(f){if(f.dataset.santoVis==='1')vis=true;});return vis;}
    function upd(){
      var on=ctaPassed&&!footVisible();
      bar.classList.toggle('is-on',on);
      bar.setAttribute('aria-hidden',on?'false':'true');
    }
    var ctaEl=$('[data-bx-cta]');
    if(ctaEl) new IntersectionObserver(function(es){es.forEach(function(en){
      /* out of view AND above the viewport top => the user has scrolled past it */
      ctaPassed=!en.isIntersecting&&en.boundingClientRect.bottom<=0;
    });upd();},{threshold:0}).observe(ctaEl);
    var fio=new IntersectionObserver(function(es){es.forEach(function(en){en.target.dataset.santoVis=en.isIntersecting?'1':'0';});upd();},{threshold:0});
    doc.querySelectorAll('footer').forEach(function(f){fio.observe(f);});
  }
})();
document.addEventListener('click',function(ev){
  var btn=ev.target.closest('.santo .faq button');
  if(!btn) return;
  var faq=btn.parentElement,a=faq.querySelector('.faq-a'),open=faq.hasAttribute('data-open');
  document.querySelectorAll('.santo .faq[data-open]').forEach(function(o){if(o!==faq){o.removeAttribute('data-open');o.querySelector('.faq-a').style.maxHeight=0;o.querySelector('button').setAttribute('aria-expanded','false');}});
  if(open){faq.removeAttribute('data-open');a.style.maxHeight=0;btn.setAttribute('aria-expanded','false');}
  else{faq.setAttribute('data-open','');a.style.maxHeight=a.scrollHeight+'px';btn.setAttribute('aria-expanded','true');}
});
(function(){
  if(matchMedia('(prefers-reduced-motion: reduce)').matches){document.querySelectorAll('.santo .reveal').forEach(function(e){e.classList.add('is-in')});return;}
  var io=new IntersectionObserver(function(es){es.forEach(function(en){if(en.isIntersecting){en.target.classList.add('is-in');io.unobserve(en.target);}})},{threshold:.12});
  document.querySelectorAll('.santo .reveal').forEach(function(e){io.observe(e)});
  setTimeout(function(){document.querySelectorAll('.santo .reveal').forEach(function(e){e.classList.add('is-in')})},2500);
})();

/* Theme-editor: secties her-initialiseren na AJAX-reload */
document.addEventListener('shopify:section:load',function(){
  document.querySelectorAll('.santo .reveal').forEach(function(e){e.classList.add('is-in')});
  var h=document.querySelector('.santo .title-panel h1');
  if(h&&document.fonts&&document.fonts.ready){document.fonts.ready.then(function(){
    h.style.fontSize='';var fs=parseFloat(getComputedStyle(h).fontSize);
    var sw=h.scrollWidth, cw=h.clientWidth;
    if(sw<=cw) return;
    var f2=Math.max(11,Math.floor(fs*(cw/sw)*2)/2);
    h.style.fontSize=f2+'px';
    var g=0;
    while(h.scrollWidth>h.clientWidth&&f2>11&&g<6){f2-=.5;h.style.fontSize=f2+'px';g++;}
  });}
});

/* Cart: AJAX add-to-cart + native Horizon drawer */
(function(){
  function drawerEl(){return document.querySelector('cart-drawer-component');}
  function openDrawer(){var d=drawerEl();if(d&&typeof d.open==='function'){d.open();return true;}return false;}
  /* The drawer is NOT opened on add. On cold ad traffic the page below the buy
     box is doing trust work; opening the cart interrupts it and forces a
     decision too early. Confirmation is the CTA label plus the count bump, and
     the drawer opens instantly from the icon when it is actually wanted. */
  var bumpTimer=null;
  function paintBump(on){
    var n=document.querySelector('[data-cart-count]');
    if(!n)return;
    if(on)n.classList.add('is-bumped'); else n.classList.remove('is-bumped');
  }
  /* The count we believe the server holds. Seeded once from the rendered
     bubble and refreshed from every cart:update that carries a real cart.
     bumpCount deliberately does NOT read the bubble back: if the text had
     already been updated elsewhere, adding to it compounds and the number
     jumps too high before the server correction pulls it back down. */
  var known=null;
  (function(){
    var n=document.querySelector('[data-cart-count]');
    if(!n)return;
    var v=parseInt((n.textContent||'').trim(),10);
    known=isNaN(v)?0:v;
  })();
  document.addEventListener('cart:update',function(ev){
    var c=ev.detail&&ev.detail.resource;
    if(c&&typeof c.item_count==='number')known=c.item_count;
    else{
      var d=ev.detail&&ev.detail.data;
      if(d&&typeof d.itemCount==='number')known=d.itemCount;
    }
  });
  function bumpCount(addQty){
    var n=document.querySelector('[data-cart-count]');
    if(n&&addQty>0&&known!==null){
      known+=addQty;
      n.textContent=String(known);
      /* an empty cart ships the bubble with [hidden]; without this the very
         first add leaves no visible confirmation until the network returns */
      n.removeAttribute('hidden');
    }
    paintBump(true);
    if(bumpTimer)clearTimeout(bumpTimer);
    bumpTimer=setTimeout(function(){paintBump(false);bumpTimer=null;},1400);
  }
  document.addEventListener('click',function(ev){
    var a=ev.target.closest('[data-santo-cart-link]');
    if(a&&drawerEl()){ev.preventDefault();openDrawer();}
  });
  document.addEventListener('submit',function(ev){
    var form=ev.target;
    if(!form||form.tagName!=='FORM')return;
    if(!form.hasAttribute('data-buybox')&&!form.closest('[data-buybox]'))return;
    if(!drawerEl())return; /* page-modus of geen drawer: normale submit */
    ev.preventDefault();
    var cta=form.querySelector('[data-cta]');if(cta){cta.disabled=true;}
    /* Open the drawer on the tap itself, not when the network returns. The add
       round trip is ~1s and the old code also waited on a second /cart.js call
       after it, so the drawer appeared ~1.4s after the tap on wifi and far later
       on 3G - long enough to read as a dead button. Now: open immediately with a
       placeholder, populate from the add response. */
    var qtyEl=form.querySelector('[name="quantity"]');
    bumpCount(parseInt(qtyEl&&qtyEl.value,10)||1);
    /* The label holds ~2s from the TAP, not from the response. Anchoring it to
       the network meant a slow connection left "Toegevoegd" on screen for as
       long as the request took plus 2s. The count bump is what persists. */
    setTimeout(revertAdded,2000);
    /* Tapped state on both CTAs: swap the label and go one step darker.
       Instant - no transition, scale or filter. Reverts when the drawer opens. */
    var marked=[];
    function markAdded(b){
      if(!b||!b.dataset.added) return;
      marked.push({el:b,label:b.textContent});
      b.textContent=b.dataset.added;
      b.classList.add('is-added');
    }
    function revertAdded(){
      marked.forEach(function(m){m.el.textContent=m.label;m.el.classList.remove('is-added');});
      marked=[];
    }
    markAdded(form.querySelector('[data-bx-cta]'));
    markAdded(document.querySelector('[data-bx-stickycta]'));
    var fd=new FormData(form);
    var ids=[];
    document.querySelectorAll('cart-items-component').forEach(function(el){if(el.dataset.sectionId){ids.push(el.dataset.sectionId);}});
    if(ids.length){fd.append('sections',ids.join(','));fd.append('sections_url',window.location.pathname);}
    fetch('/cart/add.js',{method:'POST',headers:{'Accept':'application/json','X-Requested-With':'XMLHttpRequest'},body:fd})
      .then(function(r){if(!r.ok){throw new Error('add failed');}return r.json();})
      .then(function(item){
        /* item.sections already carries the freshly rendered drawer markup, so
           there is no need for a second /cart.js round trip before painting. */
        var ev2=new Event('cart:update',{bubbles:true});
        ev2.detail={resource:null,sourceId:'santo-buybox',data:{source:'product-form-component',itemCount:null,variantId:String(item.variant_id||''),sections:item.sections||{}}};
        document.dispatchEvent(ev2);
        /* the section re-render replaces the counter node, so re-apply the
           highlight to the fresh one */
        if(bumpTimer)paintBump(true);
        /* counters read the cart resource; fetch it after the drawer is painted
           so it never blocks what the customer sees */
        fetch('/cart.js').then(function(r){return r.json();}).then(function(cart){
          var ev3=new Event('cart:update',{bubbles:true});
          ev3.detail={resource:cart,sourceId:'santo-buybox',data:{source:'product-form-component',itemCount:cart.item_count,variantId:String(item.variant_id||''),sections:{}}};
          document.dispatchEvent(ev3);
        }).catch(function(){});
      })
      .catch(function(){paintBump(false);revertAdded();try{HTMLFormElement.prototype.submit.call(form);}catch(e){window.location='/cart';}})
      .finally(function(){if(cta){cta.disabled=false;}});
  });
})();
